import axiosInstance from "../../../services/axiosInstance";


export const getSlideshow = async (params = {}) => {
    const response = await axiosInstance.get('/slideshows',  {params} );
    return response.data;
};

export const getServiceGroups = async (params = {}) => {
    const response = await axiosInstance.get(`services/groups`,  {params} );
    return response.data;
};

export const getServitorCompany = async (id,params = {}) => {
    const response = await axiosInstance.get(`services/servitor-companies/${id}`,  {params} );
    return response.data;
};
export const getAlert = async (params = {}) => {
    const response = await axiosInstance.get(`alerts`,  {params} );
    return response.data;
};


export const getOrganizationProperties = async (params = null) => {
    const response = await axiosInstance.get('config/properties', {params}  );
    return response.data;
};

export const getStates = async (params = null) => {
    const response = await axiosInstance.get('locations/states', {params} );
    return response.data;
};
export const getCities = async (params = null) => {
    const response = await axiosInstance.get('locations/cities', {params} );
    return response.data;
};
export const getServices = async (params = null) => {
    const response = await axiosInstance.get('services/services', {params} );
    return response.data;
};

export const getLastSearches = async (params = {}) => {
    const response = await axiosInstance.get(`products/last-searches`,  {params} );
    return response.data;
};